import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDutyHslsRate implements BaseEnumType {
  private static allValues: EnumDutyHslsRate[] = []; // make sure this is top-most
  
  public static none = new EnumDutyHslsRate(0, "None", "enum_duty_hsls_rate_none");
  public static low = new EnumDutyHslsRate(1, "Low", "enum_duty_hsls_rate_low");
  public static high = new EnumDutyHslsRate(2, "High", "enum_duty_hsls_rate_high");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDutyHslsRate.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDutyHslsRate.none; }
  public isLow() { return this === EnumDutyHslsRate.low; }
  public isHigh() { return this === EnumDutyHslsRate.high; }

  public static getValues(): readonly EnumDutyHslsRate[] {
    return EnumDutyHslsRate.allValues;
  }

  public static getValuesExcept0(): readonly EnumDutyHslsRate[] {
    return EnumDutyHslsRate.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDutyHslsRate {
    const found = EnumDutyHslsRate.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDutyHslsRate - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDutyHslsRate): EnumDutyHslsRate {
    const found = name ? EnumDutyHslsRate.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDutyHslsRate - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDutyHslsRate>): boolean {
    return this.key === other?.key;
  }
}